import * as ErrorService from 'shared-services/error-service';

import { debugLogEnabled } from 'services/env-service';

export const logError = (type = 'general', error, extraData) => {
    console.error(error);

    if (type === 'saga') {
        return;
    }

    ErrorService.logError({
        type,
        error,
        customData: extraData
    });
}


export const debugLog = (...args) => {
    if (!debugLogEnabled()) {
        return;
    }

    console.log(...args);
}
